// SEO Utilities for SocialBoost Platform

export const updateMetaTags = (title, description, keywords) => {
  // Update title
  document.title = title;
  
  // Update meta description
  let descriptionTag = document.querySelector('meta[name="description"]');
  if (!descriptionTag) {
    descriptionTag = document.createElement('meta');
    descriptionTag.name = 'description';
    document.head.appendChild(descriptionTag);
  }
  descriptionTag.content = description;
  
  // Update meta keywords
  let keywordsTag = document.querySelector('meta[name="keywords"]');
  if (!keywordsTag) {
    keywordsTag = document.createElement('meta');
    keywordsTag.name = 'keywords';
    document.head.appendChild(keywordsTag);
  }
  keywordsTag.content = keywords;
  
  // Update Open Graph tags
  updateOpenGraphTags(title, description);
};

export const updateOpenGraphTags = (title, description) => {
  // Update OG title
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    document.head.appendChild(ogTitle);
  }
  ogTitle.content = title;
  
  // Update OG description
  let ogDescription = document.querySelector('meta[property="og:description"]');
  if (!ogDescription) {
    ogDescription = document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    document.head.appendChild(ogDescription);
  }
  ogDescription.content = description;
};

export const updateCanonicalURL = (url) => {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
};

export const addStructuredData = (data) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
};

export const trackPageView = (pageName, pageTitle) => {
  // Google Analytics tracking
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pageName,
      page_title: pageTitle,
    });
  }
};

export const trackEvent = (eventName, eventData) => {
  // Google Analytics event tracking
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }
};

export const generateSEOContent = (language) => {
  const seoContent = {
    ar: {
      title: 'SocialBoost - منصة خدمات التواصل الاجتماعي',
      description: 'منصة متكاملة وقوية لخدمات التواصل الاجتماعي. زيادة التعليقات والإعجابات والمشاهدات والمشاركات على جميع منصات التواصل الاجتماعي',
      keywords: 'تعليقات، إعجابات، مشاهدات، مشاركات، تواصل اجتماعي، فيسبوك، انستغرام، تويتر، يوتيوب، تيك توك',
      dashboardTitle: 'لوحة التحكم',
      dashboardDescription: 'لوحة التحكم الرئيسية لإدارة خدمات التواصل الاجتماعي',
    },
    en: {
      title: 'SocialBoost - Social Media Services Platform',
      description: 'Complete and powerful social media services platform. Increase comments, likes, views, and shares on all social media platforms',
      keywords: 'comments, likes, views, shares, social media, facebook, instagram, twitter, youtube, tiktok',
      dashboardTitle: 'Dashboard',
      dashboardDescription: 'Main control panel to manage social media services',
    },
    fr: {
      title: 'SocialBoost - Plateforme de Services de Médias Sociaux',
      description: 'Plateforme complète de services de médias sociaux. Augmentez les commentaires, les j\'aime, les vues et les partages',
      keywords: 'commentaires, j\'aime, vues, partages, médias sociaux, facebook, instagram, twitter, youtube, tiktok',
      dashboardTitle: 'Tableau de Bord',
      dashboardDescription: 'Panneau de contrôle principal pour gérer les services de médias sociaux',
    },
    es: {
      title: 'SocialBoost - Plataforma de Servicios de Redes Sociales',
      description: 'Plataforma completa de servicios de redes sociales. Aumenta comentarios, me gusta, vistas y compartir',
      keywords: 'comentarios, me gusta, vistas, compartir, redes sociales, facebook, instagram, twitter, youtube, tiktok',
      dashboardTitle: 'Panel de Control',
      dashboardDescription: 'Panel de control principal para gestionar servicios de redes sociales',
    },
    de: {
      title: 'SocialBoost - Social-Media-Dienstleistungsplattform',
      description: 'Vollständige Social-Media-Dienstleistungsplattform. Erhöhen Sie Kommentare, Likes, Aufrufe und Teilen',
      keywords: 'Kommentare, Likes, Aufrufe, Teilen, soziale Medien, facebook, instagram, twitter, youtube, tiktok',
      dashboardTitle: 'Kontrollfeld',
      dashboardDescription: 'Hauptkontrollfeld zur Verwaltung von Social-Media-Diensten',
    },
    tr: {
      title: 'SocialBoost - Sosyal Medya Hizmetleri Platformu',
      description: 'Kapsamlı sosyal medya hizmetleri platformu. Yorumları, beğenileri, görüntülemeleri ve paylaşımları artırın',
      keywords: 'yorumlar, beğeniler, görüntülemeler, paylaşımlar, sosyal medya, facebook, instagram, twitter, youtube, tiktok',
      dashboardTitle: 'Kontrol Paneli',
      dashboardDescription: 'Sosyal medya hizmetlerini yönetmek için ana kontrol paneli',
    },
    hi: {
      title: 'SocialBoost - सोशल मीडिया सेवाओं का मंच',
      description: 'सोशल मीडिया सेवाओं का व्यापक मंच। टिप्पणियों, पसंद, विचारों और शेयरों को बढ़ाएं',
      keywords: 'टिप्पणियां, पसंद, विचार, शेयर, सोशल मीडिया, फेसबुक, इंस्टाग्राम, ट्विटर, यूट्यूब, टिकटॉक',
      dashboardTitle: 'नियंत्रण पैनल',
      dashboardDescription: 'सोशल मीडिया सेवाओं के प्रबंधन के लिए मुख्य नियंत्रण पैनल',
    },
    fa: {
      title: 'SocialBoost - پلتفرم خدمات رسانه های اجتماعی',
      description: 'پلتفرم جامع خدمات رسانه های اجتماعی. نظرات، پسندها، بازدیدها و اشتراک گذاری ها را افزایش دهید',
      keywords: 'نظرات، پسندها، بازدیدها، اشتراک گذاری ها، رسانه های اجتماعی، فیس بوک، اینستاگرام، توئیتر، یوتیوب، تیک توک',
      dashboardTitle: 'پنل کنترل',
      dashboardDescription: 'پنل کنترل اصلی برای مدیریت خدمات رسانه های اجتماعی',
    },
    ur: {
      title: 'SocialBoost - سوشل میڈیا سروسز کا پلیٹ فارم',
      description: 'سوشل میڈیا سروسز کا جامع پلیٹ فارم۔ تبصروں، پسند، نظارے اور شیئرز میں اضافہ کریں',
      keywords: 'تبصرے، پسند، نظارے، شیئرز، سوشل میڈیا، فیس بوک، انسٹاگرام، ٹویٹر، یوٹیوب، ٹک ٹاک',
      dashboardTitle: 'کنٹرول پینل',
      dashboardDescription: 'سوشل میڈیا سروسز کے انتظام کے لیے مرکزی کنٹرول پینل',
    },
    zh: {
      title: 'SocialBoost - 社交媒体服务平台',
      description: '完整的社交媒体服务平台。增加评论、点赞、浏览和分享',
      keywords: '评论、点赞、浏览、分享、社交媒体、脸书、Instagram、推特、YouTube、TikTok',
      dashboardTitle: '控制面板',
      dashboardDescription: '用于管理社交媒体服务的主控制面板',
    },
  };

  // Always return a valid object, even for an unexpected/unsupported code,
  // so pages never crash when reading .title / .description / .keywords.
  return seoContent[language] || seoContent.ar;
};

export const createSitemapEntry = (url, lastmod, changefreq, priority) => {
  return {
    url,
    lastmod,
    changefreq,
    priority,
  };
};

export const validateSEO = () => {
  const issues = [];
  
  // Check title
  if (!document.title || document.title.length === 0) {
    issues.push('Missing page title');
  } else if (document.title.length > 60) {
    issues.push('Title is too long (>60 characters)');
  }
  
  // Check meta description
  const description = document.querySelector('meta[name="description"]');
  if (!description || !description.content) {
    issues.push('Missing meta description');
  } else if (description.content.length > 160) {
    issues.push('Meta description is too long (>160 characters)');
  }
  
  // Check canonical URL
  const canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    issues.push('Missing canonical URL');
  }
  
  // Check Open Graph tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (!ogTitle || !ogDescription) {
    issues.push('Missing Open Graph tags');
  }
  
  return {
    isValid: issues.length === 0,
    issues,
  };
};
